
import router from "@/router";
import { MutationTypes, useStore } from "@/store";
import { computed, defineComponent, reactive, ref, toRefs } from "vue";
import searchBox from "@/components/searchBox.vue";
import { CommonService } from "@/api/common";

export default defineComponent({
  name: "SearchBanner",
  components: {
    searchBox,
  },
  setup() {
    const store = useStore();
    const search = computed(() => store.state.seachKey);
    const imgPath = ref("");
    const imgTitle = ref("搜索你喜欢的设计");
    const searchKey = reactive({
      keyValue: search.value,
    });
    const onSearch = () => {
      router.push("/templates/FL0");
      store.commit(MutationTypes.SET_SEARCH_KEY, searchKey.keyValue);
    };
    const searchInfo = ref([]);
    const getIndexSearchInfo = async () => {
      const params = {};
      const res = await CommonService.getIndexSearchInfo(params);
      searchInfo.value = res.data.data;
      imgPath.value = res.data.data.ad[0].imgUrl;
      imgTitle.value = res.data.data.ad[0].title;
    };
    getIndexSearchInfo();
    const onKey = (name: string) => {
      searchKey.keyValue = name;
      onSearch();
    };
    return {
      ...toRefs(searchKey),
      onSearch,
      onKey,
      imgPath,
      imgTitle,
      searchInfo,
    };
  },
});
